import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { ServiceMarketplaceGalleryDto } from "@green0meter/api-client";

import { Box, Typography, Card, CardContent } from "@components/base";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface ServiceGalleryProps {
  gallery: ServiceMarketplaceGalleryDto[];
}

const ServiceGallery: FC<ServiceGalleryProps> = ({ gallery }) => {
  const { t } = useTranslation();

  if (!gallery || gallery.length === 0) {
    return null;
  }

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" fontWeight={500} mb={2}>
          {t("serviceDetails.gallery")}
        </Typography>
        <Box className="slider-container" px={10}>
          <Slider {...settings}>
            {gallery.map((image) => (
              <Box key={image.id} px={1}>
                <Box>
                  <img
                    src={image.directus_files_id}
                    alt={`Gallery image ${image.id}`}
                    style={{
                      width: "100%",
                      height: "250px",
                      objectFit: "cover",
                      borderRadius: "4px",
                      cursor: "pointer",
                      transition: "transform 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.02)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  />
                </Box>
              </Box>
            ))}
          </Slider>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ServiceGallery;
